import { render, staticRenderFns } from "./RowV2.vue?vue&type=template&id=5d27e044&scoped=true"
import script from "./RowV2.vue?vue&type=script&lang=js"
export * from "./RowV2.vue?vue&type=script&lang=js"
import style0 from "./RowV2.vue?vue&type=style&index=0&id=5d27e044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d27e044",
  null
  
)

export default component.exports